import { render, staticRenderFns } from "./ApproveResponse.vue?vue&type=template&id=1b94f9c2&"
import script from "./ApproveResponse.vue?vue&type=script&lang=js&"
export * from "./ApproveResponse.vue?vue&type=script&lang=js&"
import style0 from "./ApproveResponse.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports